import {CircularProgress} from '@material-ui/core';
import * as React from 'react';
import './Loading.sass';

const Loading = () => (
  <div className="loading__progress">
    <div>
      <CircularProgress />
    </div>
  </div>
);

export default Loading;
